import Page from "../../../modules/Core/Components/Page";
import templateDefault from "../../templates/default/pages/products";

export default class Products extends Page {
  template = templateDefault;

  onAuth() {
    this.refresh();
  }

  onLoad(data) {
    super.onLoad(data);
    this.getApp().updateWindowTitle(
      `Our Products | ${this.trans("window-title")}`
    );
    this.scrollToTop();
  }
}
